module.exports = __webpack_public_path__ + "img/football.518195aa.svg";